import type { WorkspaceIntegrationType } from "@storyboard/web-client";

/** A `Record` over the enum, so a new integration type fails to compile until it has a label. */
const INTEGRATION_LABELS: Record<WorkspaceIntegrationType, string> = {
  samsara: "Samsara",
  geotab: "Geotab",
  isaac: "Isaac",
  omnitracs: "Omnitracs",
  platform_science: "Platform Science",
  western_express: "Western Express",
  wynne: "Wynne",
};

/**
 * The integration's name as a dispatcher reads it, e.g. "Platform Science".
 */
export function vendorLabel(type: WorkspaceIntegrationType): string {
  return INTEGRATION_LABELS[type];
}

/**
 * Narrows a store string to an integration type; null for null and for a type this build does not know.
 */
export function knownIntegrationType(value: string | null | undefined): WorkspaceIntegrationType | null {
  if (value == null || !isIntegrationType(value)) return null;
  return value;
}

function isIntegrationType(value: string): value is WorkspaceIntegrationType {
  return Object.hasOwn(INTEGRATION_LABELS, value);
}
